var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.758 10.2c0-.331-.285-.6-.637-.6H7.88c-.352 0-.637.269-.637.6v.4c0 .8 1.174 1.4 2.758 1.4s2.758-.6 2.758-1.4v-.4Zm-1.273-2.804C11.485 6.623 10.82 6 10 6c-.82 0-1.485.623-1.485 1.396 0 .774.665 1.4 1.485 1.4.82 0 1.485-.626 1.485-1.4ZM3 4c0-1.105.95-2 2.121-2h9.758C16.05 2 17 2.895 17 4v11.4c0 .331-.285.6-.636.6H4.273c0 .442.38.8.848.8h11.243c.351 0 .636.269.636.6 0 .331-.285.6-.636.6H5.12C3.95 18 3 17.105 3 16V4Zm1.273 0v10.8h11.454V4c0-.442-.38-.8-.848-.8H5.12c-.468 0-.848.358-.848.8Z",
    fill: "#666"
  })));
};
export default SvgAddress;